import _ from 'lodash'
import moment from 'moment'

export const camelCase = obj => {
  const serialized = {}

  _.each(obj, (value, key) => {
    serialized[_.camelCase(key)] = value
  })

  return serialized
}

export const snakeCase = obj => {
  const serialized = {}

  _.each(obj, (value, key) => {
    serialized[_.snakeCase(key)] = value
  })

  return serialized
}

export const formatDate = (value, format='YYYY-MM-DD') => {
  if (value) {
    return moment(String(value), format).format(format)
  }
  return value;
}
export const formatPrice = (value) => {
  if (value) {
    let val = (value / 1).toFixed(0).replace(".", ",");
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  return value;
}